export const today = new Date();
